import { Box, Container, Typography } from "@mui/material";
import classes from "../style";

export const CoachCguPage: React.FC = () => {
  return (
    <Box sx={classes.defiscalisation}>
      <Container maxWidth="xl">
        <Typography variant="h2">
          CONDITIONS D&#39;UTILISATION POUR LES COACHS PARTENAIRES DE HOPLÀ! COACHING
        </Typography>
        <Box className="introduction">
          <p><strong>Date de dernière mise à jour :</strong> 10/12/2013</p>

          <p>
            <h2>1. RÔLE DU DOCUMENT</h2> Les présentes conditions encadrent la collaboration entre les coachs sportifs indépendants (désignés ci-après "Coach") et la plateforme Hoplà! Coaching, exploitée par la SASU E15 (128 avenue du Docteur David Rosenfeld, 93230 Romainville, SIRET : 91842219700015).
          </p>
          <p>
            <h2>2. ACCORD DU COACH</h2> Toute inscription implique l’adhésion sans réserve aux présentes conditions. La validation se fait par une case à cocher obligatoire lors de la validation de la première séance sur la plateforme. Aucune validation de demandes de séances n’est possible sans cela.
          </p>
          <p>
            <h2>3. CONDITIONS D’ADMISSION</h2> Pour rejoindre la plateforme, le Coach doit :
          </p>
          <p>
            Démontrer ses compétences par des diplômes ainsi qu’une Carte Professionnelle,
          </p>
          <p>
            Fournir une attestation d’Assurance Responsabilité Civile Professionnelle valide,
          </p>
          <p>
            Être déclaré comme professionnel indépendant (SIRET actif),
          </p>
          <p>
            Fournir une attestation Vigilance Ursaaf,
          </p>
          <p>
            Fournir un RIB personnel,
          </p>
          <p>
            Accepter les conditions d'utilisation présentes.
          </p>
          <p>
            <h2>4. STATUT ET AUTONOMIE DU COACH</h2> Le Coach exerce à son compte, sans aucun lien hiérarchique avec Hoplà! Coaching. Il gère librement ses plannings, prestations et obligations fiscales/sociales.
          </p>
          <p>
            <h2>5. PRINCIPES DE COLLABORATION</h2> Le Coach s'engage à :
          </p>
          <p>
            Proposer des prestations de qualité et sécurisées,
          </p>
          <p>
            Honorer les rendez-vous convenus avec les Clients,
          </p>
          <p>
            Ne pas solliciter directement les clients de la plateforme pour des prestations personnelles (voir clause 9).
          </p>
          <p>
            <h2>6. RÔLE DE LA PLATEFORME</h2> La SASU E15 agit comme facilitateur entre Coachs et Clients :
          </p>
          <p>
            Elle diffuse les profils coachs sur ses canaux de communication,
          </p>
          <p>
            Elle permet la mise en relation via l'interface en ligne,
          </p>
          <p>
            Elle collecte les paiements et assure la redistribution mensuelle des rétributions aux Coachs.
          </p>
          <p>
            <h2>7. RÉMUNÉRATION DES COACHS</h2> Les Coachs sont indemnisés sous forme d’honoraires selon le tarif fixé en amont avec la plateforme (actuellement : 35 € nets par séance standard).
          </p>
          <p>
            <h2>8. ANNULATIONS ET PONCTUALITÉ</h2> Le Coach doit prévenir d’une indisponibilité au plus tôt. Un nombre excessif d’annulations, de retards pourra entraîner une suspension temporaire ou une fin de collaboration.
          </p>
          <p>
            <h2>9. CLAUSE DE NON-SOLLICITATION</h2> Durant la collaboration et pendant les 12 mois suivant la fin de celle-ci, le Coach ne peut proposer ses services, ni accepter la sollicitation de client rencontré via Hoplà! Coaching. En cas de non-respect, une indemnisation forfaitaire de 5 000 € par client concerné pourra être exigée.
          </p>
          <p>
            <h2>10. RESPONSABILITÉ PROFESSIONNELLE</h2> Le Coach assume l’entière responsabilité de ses prestations. Il est tenu de souscrire et maintenir une assurance couvrant les éventuels préjudices causés à autrui.
          </p>
          <p>
            <h2>11. CONFIDENTIALITÉ</h2> Le Coach s'engage à ne pas divulguer d'informations sensibles concernant la plateforme, ses clients ou ses activités stratégiques.
          </p>
          <p>
            <h2>12. DONNÉES PERSONNELLES</h2> Le Coach doit respecter les règles du RGPD concernant toute information personnelle des clients à laquelle il pourrait avoir accès.
          </p>
          <p>
            <h2>13. UTILISATION DES CONTENUS</h2> Les visuels, textes, et outils fournis sur la plateforme restent la propriété de la SASU E15. Toute reproduction ou utilisation en dehors du cadre défini est interdite sans autorisation préalable.
          </p>
          <p>
            <h2>14. DURÉE ET RUPTURE DE LA COLLABORATION</h2> Cette collaboration est sans engagement de durée. Chaque partie peut y mettre fin par simple notification.
          </p>
          <p>
            <h2>15. LOI APPLICABLE ET COMPÉTENCE</h2> En cas de litige, le droit français s’applique. Le tribunal compétent est celui du ressort de la SASU E15.
          </p>

        </Box>
      </Container>
    </Box>
  );
};
